"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeGuards = void 0;
class TypeGuards {
    static notUndefined(x) {
        return x !== undefined;
    }
    static isInt(value) {
        return (!TypeGuards.isNaN(value) &&
            parseInt(value, 10).toString() === value &&
            !TypeGuards.isNaN(parseInt(value, 10).toString()));
    }
    static isUndefined(value) {
        return value === undefined;
    }
    static isNull(value) {
        return value === null;
    }
    static isNaN(value) {
        return Number.isNaN(value);
    }
    static isString(value) {
        return typeof value === 'string';
    }
    static isEmpty(value) {
        return typeof value === 'object' && Object.keys(value).length === 0;
    }
    static isObject(value) {
        const type = typeof value;
        return value != null && type === 'object';
    }
    static cloneDeep(value) {
        return JSON.parse(JSON.stringify(value));
    }
    static isNullOrWhiteSpace(s) {
        return !s?.toString().trim();
    }
}
exports.TypeGuards = TypeGuards;
//# sourceMappingURL=TypeGuards.js.map